<template>
	<div class="conten" style=" background-color: #fff">
		<!-- banner -->
		<div class="banner">
			<el-carousel @change="bannerLoop" indicator-position="none" :height="bannerHeight">
				<el-carousel-item v-for="(item, index) in banner" :key="index"><img style="height: 100%;" ref="imageUrl"
						:src="item.image_uri" alt="" /></el-carousel-item>
			</el-carousel>
			<div class="banner-num">
				<div style="font-size: 30px;color: #ff1400;">0{{ bannerIndex }}</div>
				<div class="line"></div>
				<div style="font-size: 18px;" v-if="banner">0{{ banner.length }}</div>
			</div>
		</div>

		<!-- 招标信息 -->
		<div class="n-bidding">
			<div class="wrapper" style="overflow: hidden;width:92%;margin: 0 auto;">
				<div class="n-titBox clearfix" style="width: 83.333%;min-width: 1200px;margin: 0 auto; margin-bottom: 20px;">
					<div class="ntLeft">
						<p class="ftitle">
							Bidding
							<em></em>
						</p>
						<h3 class="title" style="text-align: left;">{{title}}</h3>
					</div>
					<div class="ntRigth" v-if="product.length > 0" @click="toPage('/bidding')"><a
							class="n-more">查看更多</a></div>
				</div>
				<div class="swiper_product" style="position: relative;" v-if="product.length > 0">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item, index) in product" :key="index">
							<div class="clearfix" style="padding: 0 147px;">
								<div class="tp"><img style="height: 560px;" :src="item.image_uri" alt="" /></div>
								<div class="cont" style="text-align: left;">
									<h5 class="tit" style="text-align: left;">{{ item.name }}</h5>
									<div class="nb-text clearfix">
										<span class="txt">起拍价</span>
										<p class="txt1">
											<small>￥</small>
											<b>{{ item.price }}</b>
										</p>
									</div>
									<div class="nb-text clearfix">
										<span class="txt">开始时间</span>
										<p class="txt1">{{ item.start_time_txt }}</p>
									</div>
									<div class="nb-text clearfix">
										<span class="txt">项目编号</span>
										<p class="txt1">{{ item.no }}</p>
									</div>
								<!-- 	<div class="nb-text clearfix">
										<span class="txt">煤龄</span>
										<p class="txt1">{{ item.coal_age }}年</p>
									</div> -->
									<div class="nb-text clearfix">
										<span class="txt">出煤量</span>
										<p class="txt1">{{ item.numbers }}吨</p>
									</div>
									<!-- <div class="nb-text clearfix">
										<span class="txt">面积</span>
										<p class="txt1">{{ item.area }}亩</p>
									</div> -->
									<!--     <div class="nb-text clearfix">
										<span class="txt">保证金</span>
										<p class="txt1">￥100,000</p>
									</div> -->
									<div class="nb-text clearfix">
										<span class="txt">煤矿地址</span>
										<p class="txt1">{{ item.shopping_address }}</p>
									</div>
									<a class="gd"
										@click="yanzheng('/biddingDetail',item)">{{title == '往期招标'? "查看详情" : "参与竞价"}}</a>
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-button-next"></div>
					<div class="swiper-button-prev"></div>
				</div>

				<div class="isNull" v-else>
					暂无任何招标记录
				</div>
			</div>
		</div>

		<!-- 主营产品 -->
		<div class="n-product">
			<div class="wrapper">
				<div class="n-titBox clearfix">
					<div class="ntLeft">
						<p class="ftitle">
							Product
							<em></em>
						</p>
						<h3 class="title">主营产品</h3>
					</div>
					<div class="ntRigth" v-if="porjects && porjects.category_list && porjects.category_list.length > 1">
						<a class="p-nav" :class="progectIndex == index1 ? 'progectActive' : ''"
							@click="porjects_list(item.id,index1 )" v-for="(item, index1) in porjects.category_list"
							:key="index1">{{ item.name }}</a>
						<a class="p-link" @click="toPage('/product')"><img src="../../assets/images/ico04.png" /></a>
					</div>
				</div>

				<!-- 一排四个  第四个显示半个  需要用swiper插件  自己弄哈  （好的） -->

				<div class="clearfix p-box">
					<div class=" swiper_porjects">
						<div class="swiper-wrapper">
							<div class="swiper-slide list" @click="toProject(item)"
								v-for="(item, index) in porjects.list" :key="index">
								<a>
									<img :src="item.image_uri" alt="" class="img" />
									<div class="cont">
										<em></em>
										<p style="text-align:left" :class="item.is_content == 1 ? 'arrow' : ''"
											class="tit txthide">{{ item.name }}</p>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 关于我们 -->
		<div class="n-about">
			<!-- style="background-image: url(../../assets/images/b06.jpg) center center no-repeat;background-size: cover;" -->
			<div class="img"><img :src="site_info.image_id1_url" /></div>
			<div class="cont">
				<div class="n-titBox clearfix">
					<div class="ntLeft">
						<p class="ftitle">
							About
							<em></em>
						</p>
						<h3 class="title">关于我们</h3>
					</div>
					<div class="ntRigth"><img src="../../assets/images/logo_1.png" alt="" class="logo_1" /></div>
				</div>
				<article v-html="site_info.about_us"></article>
				<a @click="toPage('/about')" class="gd"><img src="../../assets/images/ico04.png" alt="" /></a>
			</div>
		</div>

		<!-- 中标结果  公告 -->
		<div class="n-one">
			<div class="wrapper clearfix">
				<div class="n-winBidding" style="position: relative;">
					<div class="n-titBox1">
						<h3>
							中标结果
							<small>Bid winning result</small>
						</h3>
					</div>
					<table width="100%" border="0" cellspacing="0" cellpadding="0">
						<thead>
							<tr>
								<th scope="col" width="28%" style="text-align: left;padding-left: 20px;">会员编号</th>
								<th scope="col" width="24%">煤种</th>
								<th scope="col" width="24%">中标数量（吨）</th>
								<th scope="col" width="24%">发布时间</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item,index) in bidding.list" :key="index">
								<td style="text-align: left;">
									<img src="../../assets/images/ico12.png" />
									{{item.member_no}}
								</td>
								<td>{{item.coal}}</td>
								<td>{{item.numbers}}</td>
								<td>{{item.publish_time_txt}}</td>
							</tr>
						</tbody>
					</table>
					<div class="elPage" style="position: absolute;bottom: 0;">
						<el-pagination background :page-size="6" @current-change="change" @prev-click="prev()"
							@next-click="next()" layout="prev, pager, next" :total="this.count">
						</el-pagination>
					</div>
				</div>
				<div class="n-announcement">
					<div class="n-titBox1">
						<h3>
							公告
							<small>Notice</small>
						</h3>
					</div>

					<div class="swiper-container abous_us">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, index) in notice.list" style="height: auto;"
								:key="index" @click="toPage('/announcementDetail', item.id)">
								<a class="list clearfix">
									<p class="tit txthide">{{ index }}{{ item.title }}</p>
									<time>{{ item.date }}</time>
								</a>
							</div>
						</div>
						<!-- Add Pagination -->
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</div>
		</div>

		<!-- 新闻资讯 应该不用做切换了 左侧导航直接跳链接就可 -->
		<div class="n-news">
			<div class="wrapper">
				<div class="n-titBox clearfix">
					<div class="ntLeft">
						<p class="ftitle">
							NEWS
							<em></em>
						</p>
						<h3 class="title">新闻资讯</h3>
					</div>
					<div class="ntRigth" @click="toNewsPage('/news')">
						<a><img src="../../assets/images/ico04.png" alt="" /></a>
					</div>
				</div>

				<div class="flexbox">
					<div class="lNav">
						<a :class="{ active: index == newsIndex }" @click="newsChange(index, item)" :key="index"
							v-for="(item, index) in newsList.category_list">{{ item.name }}</a>
						<a class="qb" @click="toNewsPage('/news')">全部新闻</a>
					</div>
					<div class="rBox clearfix">
						<div class="swiper-container news">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in newsList.list" :key="index"
									@click="toNewsPage('/newsDetail',item.id)">
									<div class="list" style="width: 100%;">
										<a>
											<div class="pic"><img :src="item.image_uri" alt="" /></div>
											<p class="ly">{{ item.category_name }}</p>
											<p class="tit txthide">{{ item.title }}</p>
											<p class="desc txthide2">{{ item.describe }}</p>
											<p class="time">
												{{ item.time }}
												<span>查看更多 ></span>
											</p>
										</a>
									</div>
								</div>
							</div>
							<!-- Add Pagination -->
							<!-- <div class="swiper-pagination"></div> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 合作伙伴 -->
		<div class="n-partner">
			<div class="wrapper">
				<div class="n-titBox clearfix">
					<div class="ntLeft">
						<p class="ftitle">
							Partner
							<em></em>
						</p>
						<h3 class="title">合作伙伴</h3>
					</div>
					<div class="ntRigth" @click="toPage('/partner')">
						<a><img src="../../assets/images/ico04.png" alt="" /></a>
					</div>
				</div>

				<div class="clearfix">
					<!-- <div class="pic" v-if="business && business.list.length < 5" style="width: 22.8%;" @click="toPage('/partner')"><img src="../../assets/images/b11.jpg" alt="" /></div> -->
					<div class="swiper-container business">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, index) in business.list" :key="index"
								@click="toBusiness(item)">
								<div class="pic"><img :src="item.image_uri" alt="" /></div>
								<!-- <div class="pic"><img :src="item.image_uri" alt="" /></div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		{{daojishi}}
	</div>
</template>

<script>
	export default {
		name: 'home',
		data() {
			return {
				banner: '',
				bannerIndex: 1,
				bannerHeight: '800px',
				porjects: '', //主营产品
				site_info: '', //关于我们
				notice: '', //公告
				newsList: '', //新闻资讯
				newsIndex: '0', //分类
				progectIndex: '0', //分类
				business: '', //合作伙伴
				product: '',
				daojishi: '',
				bidding: [],
				page: 1,
				count: 0,
				title: '招标信息'
			};
		},
		mounted() {
			
			//主营产品
			this.porjects_list();

			//首页招标信息
			this.index_product();

			this.aboutUs();
			//公告
			this.notice_list();
			//新闻资讯
			this.news();
			//合作伙伴、、
			this.business_list();
			//增加浏览量
			this.pageviews();

			this.bidding_list();
			
			this.getBanner();
			// let _this = this
			// var time = setInterval(function () {
			//     _this.daojishi = _this.countDown(1638064901000)
			// }, 1000)
			// this.daojishi = _this.countDown(1638064901000)
		},
		methods: {
			toPage(pathName, id) {
				this.$router.push({
					path: pathName,
					query: {
						id: id
					}
				});
			},
			tabIndex(index, str) {
				// this.keyIndex = index
				// window.sessionStorage.setItem('keyIndex', index);
				// this.$setStorage('lastKeyIndex',index)
				// this.$setStorage('keyIndex',index)

				this.$router.push({
					path: str
				});
			},
			toProject(item) {
				if (item.is_content == 1) {
					this.toPage('/productDetail', item.id)
				}
			},
			toBusiness(item) {
				if (item.url) {
					window.open(item.url, '_blank');
				}
			},
			yanzheng(str, item) {
				console.log(item)
				var _this = this
				if (item.status_txt == "未开始") {
					if (_this.$getStorage('userToken')) {
						_this.$ajax('getInfo', {
								userToken: _this.$getStorage('userToken'),
							})
							.then(data => {
								if (data.status == _this.SUCCESS_CODE) {
									if (data.data.type == 2 && data.data.app_status == 1) {
										_this.toPage(str, item.id)
									} else {
										_this.$message.error('个人用户无法参与竞拍！请去个人中心修改');
									}
								} else {
									_this.$message.error(data.message);
								}
							});
					} else {
						_this.$message({
							message: '请先登录',
							type: 'warning'
						});
						_this.toPage('/login')
					}
				} else {
					_this.toPage(str, item.id)
				}
				// console.log(this.$getStorage('userToken')

			},
			countDown(time) {
				console.log(time)
				time--; //时间一秒秒的减
				let nowTime = new Date().getTime(); //现在时间
				if (nowTime <= time) {
					//获取时间差
					let timediff = Math.round((time - nowTime) / 1000);
					//获取还剩多少天
					let day = parseInt(timediff / 3600 / 24);
					//获取还剩多少小时
					let hour = parseInt((timediff / 3600) % 24);
					//获取还剩多少分钟
					let minute = parseInt((timediff / 60) % 60);
					//获取还剩多少秒
					let second = timediff % 60;
					console.log((hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (
						second < 10 ? '0' + second : second))
					return (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second <
						10 ? '0' + second : second);
				} else {
					return 0;
				}
			},
			change(e) {
				this.page = e
				this.getList()
			},
			prev(e) {
				this.page = this.page - 1
				this.getList()
			},
			next(e) {
				this.page = this.page + 1
				this.getList()
			},
			async bidding_list() {
				let {
					status,
					message,
					data
				} = await this.$ajax('winning', {
					limit: 6,
					page: this.page
				});
				if (status === this.SUCCESS_CODE) {
					this.count = data.count
					this.bidding = data
				} else {
					this.$message(message);
				}
			},
			//获取轮播图
			async getBanner(idnex) {
				this.timeIndex = idnex;
				let {
					status,
					message,
					data
				} = await this.$ajax('banner', {
					type: 1 //1 首页banner 2 内容页头部banner
				});
				if (status === this.SUCCESS_CODE) {
					this.banner = data;
					let _this = this;
					_this.$nextTick(function() {
						setTimeout(function() {
							_this.bannerHeight = _this.$refs['imageUrl'][0].offsetHeight + 'px';
						}, 300);
					});
				} else {
					this.$message(message);
				}
			},
			//首页招标信息
			async index_product() {
				let {
					status,
					message,
					data
				} = await this.$ajax('index_product', {});
				if (status == this.SUCCESS_CODE) {
					this.product = data.list;
					this.title = data.title
					let _this = this;
					this.$nextTick(function() {
						var swiperProduct = new Swiper('.swiper_product', {
							slidesPerView: 'auto',
							observer: true,
							observeParents: true,
							// spaceBetween: 10,
							navigation: {
							  nextEl: '.swiper-button-next',
							  prevEl: '.swiper-button-prev',
							},
							autoplay: {
								delay: 2500
							}
						});
					});
				} else {
					this.$message(message);
				}
			},
			//获取关于我们
			async aboutUs(idnex) {
				this.timeIndex = idnex;
				let {
					status,
					message,
					data
				} = await this.$ajax('site_info', {
					type: 1 //1 首页banner 2 内容页头部banner
				});
				if (status == this.SUCCESS_CODE) {
					this.site_info = data;
					// console.log(this.site_info.image_id1_url);
				} else {
					this.$message(message);
				}
			},
			//主营产品
			async porjects_list(id, index) {
				this.progectIndex = index
				this.porjects = [];
				let {
					status,
					message,
					data
				} = await this.$ajax('porjects_list', {
					page: 1,
					limit: '10', //	limit	字符串(string)	是
					category_id: id || 0 //	category_id	字符串(string)	是
				});
				if (status === this.SUCCESS_CODE) {
					this.porjects = data;
					let _this = this;
					this.$nextTick(function() {
						var swiperPorjects = new Swiper('.swiper_porjects', {
							slidesPerView: 'auto',
							spaceBetween: 50,
							observer: true,
							autoplay: {
								delay: 2500
							}
						});
					});
				} else {
					this.$message(message);
				}
			},
			destroy() {},
			//公告
			async notice_list(id) {
				let {
					status,
					message,
					data
				} = await this.$ajax('notice', {
					page: 1,
					limit: '30' //	limit	字符串(string)	是
				});
				if (status == this.SUCCESS_CODE) {
					this.notice = data;
					this.$nextTick(function() {
						var abousUs = new Swiper('.abous_us', {
							direction: 'vertical',
							slidesPerView: 10,
							spaceBetween: 10,
							autoplay: {
								delay: 2500
							}
							// mousewheel: true,
						});
					});
				} else {
					this.$message(message);
				}
			},

			//新闻资讯
			async news(id) {
				let {
					status,
					message,
					data
				} = await this.$ajax('news', {
					page: 1,
					limit: '30', //	limit	字符串(string)	是
					category_id: id || 0 //    category_id    字符串(string)    是
				});
				if (status == this.SUCCESS_CODE) {
					this.newsList = data;
					this.$nextTick(function() {
						var newSwiper = new Swiper('.news', {
							slidesPerView: 3.7,
							spaceBetween: 20,
							autoplay: {
								delay: 2500,
								disableOnInteraction: false
							}
						});
					});
				} else {
					this.$message(message);
				}
			},
			//合作伙伴
			async business_list(id) {
				let {
					status,
					message,
					data
				} = await this.$ajax('business_list', {
					page: 1,
					limit: '30', //	limit	字符串(string)	是
					id
				});
				if (status == this.SUCCESS_CODE) {
					this.business = data;
					this.$nextTick(function() {
						var swiper = new Swiper('.business', {
							slidesPerView: 5.8,
							spaceBetween: 20,
							autoplay: {
								delay: 2500,
								disableOnInteraction: false
							}
						});
					});
				} else {
					this.$message(message);
				}
			},

			//增加浏览量
			async pageviews(idnex) {
				let {
					status,
					message,
					data
				} = await this.$ajax('pageviews', {});
				if (status === this.SUCCESS_CODE) {} else {
					// this.$message(message);
				}
			},
			newsChange(index, item) {
				this.newsIndex = index;
				this.news(item.id);
			},
			toNewsPage(str, id) {
				var that = this
				if (id) {
					that.$router.push({
						path: str,
						query: {
							id: id
						}
					});
				} else {
					that.$router.push({
						path: str,
						query: {
							index: that.newsIndex
						}
					});
				}
			},
			bannerLoop(index) {
				this.bannerIndex = index + 1;
			},

		}
	};
</script>

<style>
	@import '../../assets/swiper-bundle.min.css';
.line {
		height: 20px;
		width: 1px;
		background: #fff;
		margin: 0 10px;
	}
	.isNull {
		width: 100%;
		text-align: center;
		font-size: 25px;
		font-weight: bold;
		padding: 10px;
	}

	.banner-num {
		display: flex;
		position: absolute;
		left: 160px;
		bottom: 88px;
		color: #fff;
		z-index: 9999;
		align-items: center;
	}

	.abous_us {
		overflow: hidden;
		height: 550px;
	}

	.line {
		height: 20px;
		width: 1px;
		background: #fff;
		margin: 0 10px;
	}

	/* .conten {
    background-color: #fff !important;
} */
	/* 标题 */
	.n-titBox {
		margin-bottom: 35px;
	}

	.n-titBox .ntLeft {
		float: left;
		color: #333333;
		font-weight: bold;
	}

	.n-titBox .ntRigth {
		float: right;
		padding-top: 65px;
	}

	.n-titBox .ftitle {
		font-size: 72px;
		text-transform: uppercase;
		line-height: 95px;
	}

	.n-titBox .ftitle em {
		display: inline-block;
		width: 15px;
		height: 15px;
		background: #af2f24;
		margin-left: 55px;
	}

	.n-titBox .title {
		font-size: 32px;
		line-height: 70px;
		text-align: left;
	}

	.n-titBox .n-more {
		display: block;
		width: 120px;
		height: 42px;
		border: 1px solid #af2f24;
		border-radius: 42px;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		color: #af2f24;
		text-transform: uppercase;
		transition: 0.5s;
	}

	.n-titBox .n-more:hover {
		background: #af2f24;
		color: #fff;
	}

	/* 首页 招聘信息 */
	.n-bidding {
		padding: 75px 0 85px;
		color: #333333;
	}

	.n-bidding .tp {
		width: 46.25%;
		float: left;
		transition: 0.5s;
	}

	.n-bidding .tp img {
		display: block;
		width: 100%;
	}

	.n-bidding .cont {
		width: 47.5%;
		float: right;
		line-height: 1.4;
		padding-top: 20px;
	}

	.n-bidding .tit {
		font-size: 32px;
	}

	.n-bidding .nb-text {
		font-size: 22px;
		margin-top: 15px;
	}

	.n-bidding .nb-text .txt {
		color: #999999;
		width: 90px;
		text-align-last: justify;
		display: inline-block;
		vertical-align: top;
	}

	.n-bidding .nb-text .txt1 {
		width: calc(100% - 100px);
		display: inline-block;
		padding-left: 20px;
		vertical-align: top;
	}

	.n-bidding .nb-text b {
		font-size: 34px;
	}

	.n-bidding .nb-text b,
	.n-bidding .nb-text small {
		color: #af2f24;
	}

	.n-bidding .nb-text:nth-child(2) .txt,
	.n-bidding .nb-text:nth-child(2) .txt1 {
		vertical-align: bottom;
	}

	.n-bidding .gd {
		display: block;
		width: 260px;
		height: 50px;
		background: #af2f24;
		border-radius: 5px;
		text-align: center;
		line-height: 50px;
		font-size: 22px;
		margin-top: 45px;
		color: #fff;
		transition: 0.5s;
	}

	.n-bidding .tp:hover {
		box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
		-webkit-transform: translateY(-5px);
		-moz-transform: translateY(-5px);
		-ms-transform: translateY(-5px);
		-o-transform: translateY(-5px);
		transform: translateY(-5px);
	}

	.n-bidding .gd:hover {
		box-shadow: 3px 3px 3px #af2f24;
		-webkit-transform: translateY(-3px);
		-moz-transform: translateY(-3px);
		-ms-transform: translateY(-3px);
		-o-transform: translateY(-3px);
		transform: translateY(-3px);
	}

	@media screen and (max-width: 1600px) {
		.n-bidding .cont {
			padding-top: 15px;
		}

		.n-bidding .tit {
			font-size: 28px;
		}

		.n-bidding .nb-text {
			font-size: 18px;
			margin-top: 10px;
		}

		.n-bidding .nb-text b {
			font-size: 32px;
		}

		.n-bidding .gd {
			width: 220px;
			height: 40px;
			line-height: 40px;
			font-size: 18px;
			margin-top: 30px;
		}
	}

	/* 首页 主营产品 */
	.n-product {
		width: 100%;
		padding: 75px 0 110px;
		background: url(../../assets/images/bj01.jpg) center bottom no-repeat;
		overflow: hidden;
	}

	.n-product .p-nav {
		float: left;
		font-size: 18px;
		color: #666666;
		font-weight: bold;
		line-height: 38px;
		margin-right: 65px;
		position: relative;
		transition: 0.5s;
	}

	.n-product .p-nav:after {
		content: '';
		display: block;
		width: 0;
		height: 2px;
		margin: 0 auto;
		background: #af2f24;
		position: absolute;
		bottom: -2px;
		left: 0;
		right: 0;
		transition: 0.5s;
	}

	.progectActive {
		color: #af2f24 !important;
		border-bottom: 2px solid #af2f24 !important;
	}

	.n-product .p-nav:hover {
		color: #af2f24;
	}

	.n-product .p-nav:hover:after {
		width: 95%;
	}

	.n-product .p-link {
		display: block;
		height: 40px;
		float: left;
		line-height: 35px;
	}

	.n-product .p-link img {
		width: 100%;
	}

	.n-product .p-box {
		width: 100%;
	}

	.n-product .swiper_porjects {
		overflow: hidden;
		position: relative;
	}

	.n-product .list {
		width: 434px !important;
		height: 551px;
		float: left;
		position: relative;
	}

	.n-product .list a {
		display: block;
		width: 100%;
		height: 100%;
	}

	.n-product .list .img {
		display: block;
		width: 100%;
		min-height: 100%;
	}

	.n-product .list .cont {
		background: rgba(0, 0, 0, 0.6);
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 150px;
		color: #fff;
		padding: 45px 30px 0;
		transition: 0.5s;
	}

	.n-product .list em {
		display: block;
		width: 50px;
		height: 2px;
		background: #ffcfb0;
		margin-bottom: 15px;
	}

	.n-product .list .tit {
		font-size: 24px;
		line-height: 35px;
		padding-right: 80px;
		/* background: url(../../assets/images/ico11.png) right center no-repeat; */
	}

	.arrow {
		background: url(../../assets/images/ico11.png) right center no-repeat;
	}

	.n-product .list:hover .cont {
		background: rgba(126, 10, 0, 0.6);
	}

	@media screen and (max-width: 1600px) {
		.n-product .p-nav {
			margin-right: 45px;
		}

		.progectActive {
			color: #af2f24 !important;
			border-bottom: 2px solid #af2f24 !important;
		}

		.n-product .p-nav .active {
			color: #af2f24 !important;

		}

		.n-product .list {
			width: 310px;
			height: 445px;
		}

		.n-product .list .cont {
			height: 120px;
			padding: 30px 20px 0;
		}

		.n-product .list em {
			width: 35px;
		}

		.n-product .list .tit {
			font-size: 20px;
			line-height: 30px;
		}
	}

	@media screen and (max-width: 1440px) {
		.n-product .p-box {
			/* width: calc((100vw - 1400px) / 2 + 1200px); */
			width: 100%;
		}
	}

	@media screen and (max-width: 1280px) {
		.n-product .p-box {
			width: calc((1280 - 1200px) / 2 + 1200px);
		}
	}

	/* 首页 关于我们 */
	.n-about {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.n-about .img {
		width: 51.042%;
		height: 940px;
	}

	.n-about .cont {
		width: 67.448%;
		height: 715px;
		background: url(../../assets/images/bj02.jpg) center bottom no-repeat #fff;
		background-size: 100%;
		margin: auto 0;
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		padding: 75px 7.813% 0;
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}

	.n-about .cont article {
		font-size: 16px;
		text-align: justify;
		line-height: 30px;
		color: #333333;
		margin-bottom: 90px;
	}

	.n-about .cont .gd {
		display: block;
		width: 42px;
	}

	.n-about .cont .gd img {
		display: block;
		width: 100%;
	}

	/* 首页 中标结果  公告 */
	.n-one {
		width: 100%;
		background: #edeff5;
		padding: 110px 0;
	}

	.n-one .wrapper {
		width: 88.021%;
		min-width: 1200px;
		background: #fff;
		padding: 30px 0;
		position: relative;
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
	}

	.n-titBox1 {
		height: 35px;
		border-left: 8px solid #af2f24;
		padding-left: 20px;
		line-height: 35px;
		margin-bottom: 40px;
	
	}
	.n-titBox1 th{
		font-size: 26px;
	
	}
	.n-titBox1 h3 {
		font-size: 27px;
		float: left;
	}

	.n-titBox1 small {
		font-size: 21px;
		color: #b5b5b5;
		text-transform: uppercase;
		display: inline-block;
		margin-left: 18px;
	}

	.n-winBidding {
		width: 69.031%;
		height: 650px;
		padding: 25px 35px;
		border-right: 1px solid #d5d5d5;
		float: left;
	}

	/* .n-winBidding table,.n-winBidding table tr,.n-winBidding table th,.n-winBidding table td{border: 0;} */
	.n-winBidding table {
		font-size: 18px;
		color: #333333;
		text-align: center;
	}

	.n-winBidding table th {
		background: #af2f24;
		color: #fff;
		font-weight: initial;
	}

	.n-winBidding table tr {
		cursor: default;
		line-height: 30px;
		transition: 0.5s;
	}

	.n-winBidding table th {
		padding: 11px 0;
	}

	.n-winBidding table td {
		padding: 20px 0 4px;
	}

	.n-winBidding table tr:hover {
		color: #af2f24;
	}

	.n-announcement {
		width: 30.969%;
		height: 650px;
		padding: 25px 35px;
		float: right;
	}

	.n-announcement .list {
		display: block;
		height: 54px;
		font-size: 18px;
		color: #333333;
		line-height: 54px;
		transition: 0.5s;
	}

	.n-announcement .list .tit {
		text-align: left;
		width: calc(100% - 108px);
		float: left;
		padding-left: 18px;
		background: url(../../assets/images/ico12.png) left center no-repeat;
	}

	.n-announcement .list time {
		float: right;
		display: block;
	}

	.n-announcement .list:hover {
		color: #af2f24;
	}

	@media screen and (max-width: 1440px) {
		.n-announcement .list .tit {
			width: calc(100% - 80px);
		}
	}

	/* 首页 新闻资讯 */
	.n-news {
		width: 100%;
		padding: 75px 0 85px;
	}

	.n-news .lNav {
		width: 200px;
		position: relative;
		padding-bottom: 100px;
	}

	.n-news .lNav a {
		display: block;
		font-size: 20px;
		color: #999999;
		line-height: 45px;
		transition: 0.5s;
	}

	.n-news .lNav a.qb {
		color: #333333;
		position: absolute;
		bottom: 0;
		font-size: 19px;
	}

	.n-news .lNav a:hover,
	.n-news .lNav a.active {
		color: #af2f24;
		font-weight: bold;
	}

	.n-news .rBox {
		width: calc(100% - 200px);
	}

	.n-news .list {
		width: 100%;
		float: left;
		margin-left: 5.333%;
	}

	.n-news .list a {
		display: block;
		width: 100%;
		color: #999999;
		font-size: 14px;
		transiiton: 0.5s;
	}

	.n-news .list .pic {
		width: 100%;
		height: 14.063vw;
	}

	.n-news .list .ly {
		font-size: 18px;
		height: 50px;
		line-height: 50px;
		margin-top: 10px;
	}

	.n-news .list .tit {
		font-size: 22px;
		color: #333333;
		font-weight: bold;
		line-height: 35px;
	}

	.n-news .list .desc {
		line-height: 30px;
		height: 60px;
		margin: 10px 0 40px;
	}

	.n-news .list .time { 
		border-top: 1px solid #e8e8e8;
		height: 56px;
		line-height: 55px;
		font-size: 18px;
		text-align: left;
	}

	.n-news .list .time span {
		float: right;
		font-size: 15px;
	}

	.n-news .list:hover a,
	.n-news .list:hover .tit {
		color: #af2f24;
	}

	.n-news .list:hover .time {
		border-color: #af2f24;
	}

	@media screen and (max-width: 1280px) {
		.n-news .list .pic {
			height: 192px;
		}

		.n-news .list .ly {
			height: 40px;
			line-height: 40px;
		}

		.n-news .list .desc {
			margin-bottom: 30px;
		}

		.n-news .list .time {
			height: 66px;
			line-height: 65px;
		}
	}

	/* 首页 合作伙伴 */
	.n-partner {
		width: 100%;
		background: url(../../assets/images/bj03.jpg) center center no-repeat;
		padding: 85px 0 65px;
	}

	.n-partner .pic {
		width: 100%;
		height: 153px;
		background: #fff;
		border-radius: 5px;
		float: left;
		margin-right: 3.125%;
		transition: 0.5s;
	}

	.n-partner .pic:nth-child(5n) {
		margin-right: 0;
	}

	.n-partner .pic img {
		min-height: auto;
	}

	.n-partner .pic:hover,
	.n-partner .pic.active {
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}

	.n-partner .btn {
		margin: 70px auto 0;
		width: 110px;
	}

	.n-partner .btn .an {
		width: 17px;
		cursor: pointer;
	}

	.n-partner .btn .an img {
		display: block;
		width: 100%;
	}

	.n-partner .btn .prev {
		float: left;
	}

	.n-partner .btn .next {
		float: right;
	}

	@media screen and (max-width: 1440px) {
		.n-partner .pic {
			height: 120px;
		}
	}

	.elPage {
		width: 100%;
		margin-top: 20px;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #8a0d02;
	}

	.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #8a0d02;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
		color: #fff;
	}

	.swiper_product{
	    --swiper-navigation-color: #c50f02;/* 单独设置按钮颜色*/ 
		
	  }
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue